import { Message } from '@/shared/components/chat/types/Message'
import { defineStore } from 'pinia'

export type { Message }

const initialMessage =
  'Hola soy Apsi tu asistente virtual, puedes consultar información sobre tus datos laborales, vacaciones, licencias, politicas e información general de la plataforma.'

export const useChatStore = defineStore('chat', {
  state: () => ({
    messages: [
      {
        sender: 'assistant',
        text: initialMessage,
        type: 'text',
        json: {},
        timestamp: new Date().toISOString(),
      },
    ] as Array<Message>,
    context: [],
  }),
  getters: {
    getMessages(state) {
      return state.messages
    },
  },
  actions: {
    addMessage(message: Message) {
      this.messages.push(message)
    },
    clearMessages() {
      this.messages = [
        {
          sender: 'assistant',
          text: initialMessage,
          type: 'text',
          json: {},
          timestamp: new Date().toISOString(),
        },
      ]
      this.context = []
    },
    setContext(context: any) {
      this.context = context
    },
    clearContext() {
      this.context = []
    },
  },
  persist: true,
})
